import { render, staticRenderFns } from "./MultiPaneLayout.vue?vue&type=template&id=c5e2a3e2&scoped=true"
import script from "./MultiPaneLayout.vue?vue&type=script&lang=js"
export * from "./MultiPaneLayout.vue?vue&type=script&lang=js"
import style0 from "./MultiPaneLayout.vue?vue&type=style&index=0&id=c5e2a3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e2a3e2",
  null
  
)

export default component.exports